import api from "../api";

class Ivt {
  getList = (data) => {
    return api.getGCP("api/v1/bigquery/get-ivt-list", null, data);
  };
}
// eslint-disable-next-line
export default new Ivt();
